import React from 'react';
import { Paper, PaperProps } from '@mui/material';

/**
 * Стандартна картка-обгортка для контенту сторінки.
 * Усі табличні/спискові сторінки використовують цей компонент.
 * Щоб змінити відступи глобально — редагуйте лише тут.
 */
export const PageCard: React.FC<PaperProps> = ({ children, sx, ...props }) => (
  <Paper sx={{ p: 2, ...sx }} {...props}>
    {children}
  </Paper>
);
